import { Subject } from 'rxjs';

export class UpdateEventEmitter extends Subject<any>{
    constructor() {
        super();
    }
    emit(value) { super.next(value); }
}